import apolloClient from './../apolloClient.js'
import createUserPolicies from './../helpers/createUserPolicies'

const state = {
  user: {}
}

const mutations = {
  SET_VIEWED_USER (state, userObj) {
    state.user = createUserPolicies(userObj)
  },
  UPDATE_VIEWED_AVATAR (state, filePath) {
    state.user.avatar = filePath
  },
  UPDATE_VIEWED_USER (state, userObj) {
    state.user = createUserPolicies(userObj)
  }
  // SET_VIEWED_USER_IS_ADMIN (state, value) {
  //   state.user.isAdmin = value
  // },
  // SET_VIEWED_USER_ROLE (state, value) {
  //   state.user.role = value
  // }
}

import getUserByIdQuery from './../gql/queries/getUserById.graphql'
import updateUserProfileMutation from './../gql/mutations/UpdateUserProfile.graphql'

const actions = {
  getUserById: ({commit}, id) => {
    return new Promise((resolve, reject) => {
      apolloClient.query({
        query: getUserByIdQuery,
        variables: {
          id
        }
      }).then((result) => {
        commit('SET_VIEWED_USER', result.data.user)
        resolve()
      }).catch((error) => {
        console.log(error)
        reject()
      })
    })
  },
  updateUserProfile: ({state, commit}, params) => {
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: updateUserProfileMutation,
        variables: params
      })
        .then((result) => {
          commit('UPDATE_VIEWED_USER', result.data.updateUserProfile)
          resolve(result.data.updateUserProfile)
        }).catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  }
}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/store/userStore.js